export const environment = {
    api: "https://project.exis.dev.iqsw.cz",
    loginUrl: "https://login.exprojekt.cz/realms/EXprojekt/protocol/openid-connect/auth?client_id=exis&redirect_uri=https://admin.exis.dev.iqsw.cz/auth&state=auth&response_type=code&scope=openid",
};
